import React from 'react';
import { Modal } from '../basic';
import ScheduleUpload from './ScheduleUpload';

interface ScheduleUploadModalProps {
  isOpen: boolean;
  onClose: () => void;
  onUploadComplete?: () => void;
}

const ScheduleUploadModal: React.FC<ScheduleUploadModalProps> = ({ isOpen, onClose, onUploadComplete }) => {
  const handleUploadComplete = () => {
    if (onUploadComplete) {
      onUploadComplete();
    }
    // Don't automatically close - let the user close via result modal
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} maxWidth="2xl">
      <ScheduleUpload onUploadComplete={handleUploadComplete} onClose={onClose} />
    </Modal>
  );
};

export default ScheduleUploadModal;
